module.exports = __webpack_public_path__ + "content/4971e63064270f2ab34b9e7bda04e4ac.png";